import { requestPerformancePrefix } from '../constants';
import XHRQueue from '../storage/xhr';
import {
  IError,
  IPerformance,
  IResponseHandlerData,
  IXhrPerformance,
} from '../types';
import Ajax from './ajax';
import debounce from './debounce';
import {
  assignDefaultData,
  currentVisitId,
  formatUrl,
  getDeviceToken,
  stringifyJSONIfPossible,
} from './func';
import logger from './logger';
import SystemOptions from './options';

/**
 * 请求响应成功处理函数
 * @param resData
 */
export function handleSuccessResponse(resData: IResponseHandlerData) {
  const { url, apiType, statusCode, method, data, traceId, async } = resData;
  const options = SystemOptions.getInstance().getOptions();
  const api = formatUrl(url);
  const {
    performanceStartPrefix,
    performanceEndPrefix,
    measurePerformancePrefix,
  } = requestPerformancePrefix[apiType];

  if (options.debug) {
    logger.info(`${apiType} send[url: ${api}, TraceId: ${traceId}]`);
  }

  window.performance.mark(`${performanceEndPrefix}${api}`);

  if (window.performance.getEntriesByName(`${performanceStartPrefix}${api}`).length > 0) {
    window.performance.measure(
      `${measurePerformancePrefix}${api}`,
      `${performanceStartPrefix}${api}`,
      `${performanceEndPrefix}${api}`,
    );

    const measureInfo = window.performance.getEntriesByName(`${measurePerformancePrefix}${api}`);

    if (measureInfo.length > 0) {
      const xhrQueueInstance = XHRQueue.getInstance();
      const xhrItem: IXhrPerformance = {
        name: url || '',
        entryType: apiType,
        startTime: measureInfo[0].startTime,
        duration: measureInfo[0].duration,
        xhrDetail: {
          method,
          api,
          traceId,
          async,
          statusCode,
          payload: stringifyJSONIfPossible(data),
        },
      };

      xhrQueueInstance.push(xhrItem);

      // TODO 策略优化
      // magic handler
      if (xhrQueueInstance.size() !== 0) {
        const sendXHRData = debounce(() => {
          if (xhrQueueInstance.size() !== 0) {
            const xhrData: IPerformance = {
              resource: xhrQueueInstance.list(),
              browserId: getDeviceToken(options.deviceTokenKey),
              visitId: currentVisitId,
            };

            Ajax.send(assignDefaultData(xhrData, options), options.performanceApiUrl);
            xhrQueueInstance.clear();
          }
        }, options.debounceThreshold);

        sendXHRData();
      }
    }
  }
}

/**
 * 请求响应失败处理函数
 * @param resData
 */
export function handleErrorResponse(resData: IResponseHandlerData) {
  const { url, apiType, statusCode, method, data, traceId, async } = resData;
  const optionsInstance = SystemOptions.getInstance();
  const options = optionsInstance.getOptions();
  const api = formatUrl(url);
  const { errorName, errorMessage } = requestPerformancePrefix[apiType];

  if (optionsInstance.getCurrentLogCount() < options.maxLogCount) {
    if (options.debug) {
      logger.info(`${apiType} error[url: ${api}, TraceId: ${traceId}]`);
    }

    const formatData: IError = assignDefaultData({
      name: errorName,
      message: errorMessage,
      url: window.location.href,
      xhrDetail: {
        method,
        traceId,
        async,
        statusCode,
        api: url,
        payload: stringifyJSONIfPossible(data),
      },
    }, options);

    Ajax.send(formatData, options.exceptionApiUrl);
    optionsInstance.increaseCurrentLogCount();
  }
}
